import React from 'react';
import { ScheduleRow } from '../../utils/finance';
import { formatARS } from '../../utils/format';
export function AmortizationTable({
  rows
}: {
  rows: ScheduleRow[];
}) {
  return <div className="max-h-80 overflow-auto rounded-xl border border-line" data-id="element-949" data-mp="2rhkn13ykdhdz">
      <table className="w-full text-right text-sm" data-id="element-950" data-mp="2rfhn9s7m09w2">
        <caption className="sr-only" data-id="element-951" data-mp="2mjsinagqg2sw">Cuadro de amortización estimado</caption>
        <thead className="sticky top-0 bg-panel text-xs text-mist" data-id="element-952" data-mp="3k71cptusuk6i">
          <tr data-id="element-953" data-mp="3k45f66mv5xil">
            <th scope="col" className="px-3 py-2 text-left font-medium" data-id="element-954" data-mp="3f7oe6bukfoo3">Cuota</th>
            <th scope="col" className="px-3 py-2 font-medium" data-id="element-955" data-mp="3f5lqvzkss9n2">Valor</th>
            <th scope="col" className="px-3 py-2 font-medium" data-id="element-956" data-mp="3a6qyc5x136pr">Interés</th>
            <th scope="col" className="px-3 py-2 font-medium" data-id="element-957" data-mp="365owdhbq8gk3">Capital</th>
            <th scope="col" className="px-3 py-2 font-medium" data-id="element-958" data-mp="1yswz10mfkdwq">Saldo</th>
          </tr>
        </thead>
        <tbody className="divide-y divide-line" data-id="element-959" data-mp="1urtkchg4cnx3">
          {rows.map(r => <tr key={r.n} data-id="element-960" data-mp="2o15xvd1a1bui">
              <td className="px-3 py-2 text-left text-mist" data-id="element-961" data-mp="2o0npxj59596r">{r.n}</td>
              <td className="px-3 py-2 font-medium" data-id="element-962" data-mp="2t08s02fpxxnp">{formatARS(r.installment)}</td>
              <td className="px-3 py-2 text-mist" data-id="element-963" data-mp="2sy62rkme48k1">{formatARS(r.interest)}</td>
              <td className="px-3 py-2 text-mist" data-id="element-964" data-mp="2ezxzkuyrgb0f">{formatARS(r.principal)}</td>
              <td className="px-3 py-2 text-mist" data-id="element-965" data-mp="2j11ftikq0926">{formatARS(r.balance)}</td>
            </tr>)}
        </tbody>
      </table>
    </div>;
}